<template>
    <div>
        <LicenseCreate ref="licenseCreate" v-show="action == 'create'" @onBackKey="onBackKey"></LicenseCreate>
        <LicenseSearch ref="licenseSearch" v-show="action == 'search'" @onRowClick="onRowClick" @onSetValuesClick="onSetValuesClick" @onCreateClick="onCreateClick"></LicenseSearch>
        <LicenseView ref="licenseView" v-show="action == 'view'" @onBackKey="onBackKey" :editingLicense="editingLicense"></LicenseView>
        <LicenseEdit ref="licenseEdit" :licenses="selectedItems" v-show="action == 'edit'" @onBackKey="onBackKey"></LicenseEdit>
    </div>
</template>

<script>
import LicenseCreate from "./LicenseCreate.vue";
import LicenseSearch from "./LicenseSearch.vue";
import LicenseView from "./LicenseView.vue";
import LicenseEdit from "./LicenseEdit.vue";

export default {
    name: "Licenses",
    components: {
        LicenseCreate,
        LicenseSearch,
        LicenseView,
        LicenseEdit,
    },
    data() {
        return {
            singleSelect: false,
            selected: [],
            title: "Licenses",
            isBusy: false,
            action: "search",
            dialog: false,
            editedIndex: -1,
            editedItem: {
                notedBy: "",
                note: "",
            },
            selectedItems: [],
            editingLicense: {
            },
        };
    },
    mounted() {
    },
    methods: {
        onBackKey() {
            this.action = "search";
            this.$refs.licenseSearch.onBackKey();
        },
        onCreateClick() {
            this.action = "create";
            this.$refs.licenseCreate.resetCreate();
        },
        onRowClick(selectedItem) {
            this.action = "view";
            this.$refs.licenseView.licenseStep = "D";
            this.editingLicense = selectedItem;
        },
        onSelectionChanged(selectedItem) {
            this.action = "view";
            this.editingLicense = selectedItem.item;
        },
        onSetValuesClick(selectedItems) {
            this.action = "edit";
            this.selectedItems = selectedItems;
        },
    },
};
</script>
